import React, { useCallback } from 'react'
import { Col, Row } from '../../../../../ui/atoms/Grid'
import { BtInput } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { Spacer } from '../../../../../ui/atoms'
import {
  validateLetterAndWhiteSpace,
  validateUSPhoneNumber,
} from '@linqpal/models/src/helpers/validations'
import { AutoCapitalize, KeyboardType } from '@linqpal/models/src/dictionaries'
import { BtPhoneInput } from '@linqpal/components/src/ui/BtPhoneInput'

export const UserDetailsForm = ({ user, review, onChange }) => {
  const { t } = useTranslation('application')

  const validatePhone = useCallback(
    (value: string) =>
      validateUSPhoneNumber(value) ? '' : t('ValidationErrors.InvalidPhone'),
    [t],
  )

  return (
    <>
      <Row>
        <Col xs={12} sm={12} md={6} xl={6}>
          <BtInput
            model={user}
            name="firstName"
            label={t('Finance.FirstnameLabel')}
            validateInput={(name) => {
              if (!validateLetterAndWhiteSpace(name))
                return t('Finance.FirstNameError')
              return false
            }}
            disabled={review}
            style={{ marginTop: review ? 24 : 30 }}
            maxLength={70}
            onChange={() => onChange(user)}
            autoCapitalize={AutoCapitalize.Words}
            testID="invitee_first_name"
          />
        </Col>
        <Col xs={12} sm={12} md={6} xl={6}>
          <BtInput
            model={user}
            name="lastName"
            label={t('Finance.LastnameLabel')}
            validateInput={(lastName) => {
              if (!validateLetterAndWhiteSpace(lastName))
                return t('Finance.LastNameError')
              return false
            }}
            disabled={review}
            style={{ marginTop: review ? 24 : 30 }}
            maxLength={70}
            onChange={() => onChange(user)}
            autoCapitalize={AutoCapitalize.Words}
            testID="invitee_lasr_name"
          />
        </Col>
      </Row>
      <Spacer height={review ? 24 : 30} />
      <BtPhoneInput
        value={user.phone}
        label={t('Finance.PhoneLabel')}
        validate={validatePhone}
        disabled={review}
        onChangeText={(value) => {
          if (user.setValue) {
            user.setValue('phone', value.parsed)
          } else {
            user.phone = value.parsed
          }
          onChange(user)
        }}
        testID="invitee_phone"
      />
      <BtInput
        model={user}
        name="email"
        label={t('Finance.EmailLabel')}
        disabled={review}
        style={{ marginTop: review ? 24 : 30 }}
        validateInput={() => {
          if (!user.validEmail) return 'Invalid email'
          else return ''
        }}
        validateInputOnBlur
        maxLength={255}
        onChange={() => onChange(user)}
        keyboardType={KeyboardType.EmailAddress}
        testID="invitee_email"
      />
    </>
  )
}
